import { ButtonBase } from '@mui/material';
import React from 'react';
import theme, { TMaterialStyleItem, TMaterialStyles } from '../../theme';

export type TButtonWithShadow =
  | 'PRIMARY'
  | 'SUCCESS'
  | 'LIGHT_SUCCESS'
  | 'ERROR'
  | 'DISABLED'
  | 'GOLD'
  | 'BRONZE'
  | 'SILVER'
  | 'PRIMARY_DARK'
  | 'DARK';

interface IButtonWithShadow extends React.PropsWithChildren {
  sx?: TMaterialStyleItem;
  type?: TButtonWithShadow;
  onClick?: () => void;
  disabled?: boolean;
}

export const ButtonWithShadow: React.FC<IButtonWithShadow> = ({
  children,
  type = 'PRIMARY',
  sx,
  onClick,
  disabled,
}) => {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      sx={[
        materialStyles.buttonContainer,
        type === 'PRIMARY' ? materialStyles.primaryButtonContainer : null,
        type === 'SUCCESS' ? materialStyles.successButtonContainer : null,
        type === 'LIGHT_SUCCESS'
          ? materialStyles.lightSuccessButtonContainer
          : null,
        type === 'ERROR' ? materialStyles.errorButtonContainer : null,
        type === 'DISABLED' ? materialStyles.buttonDisabled : null,
        type === 'GOLD' ? materialStyles.buttonGold : null,
        type === 'BRONZE' ? materialStyles.buttonBronze : null,
        type === 'SILVER' ? materialStyles.buttonSilver : null,
        type === 'PRIMARY_DARK' ? materialStyles.buttonPrimaryDark : null,
        type === 'DARK' ? materialStyles.buttonDark : null,
        sx || null,
      ]}
    >
      {children}
    </ButtonBase>
  );
};

const materialStyles: TMaterialStyles = {
  buttonContainer: {
    color: theme.palette.text.primary,
  },
  primaryButtonContainer: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: `0px 4px 0px ${theme.palette.primary.dark}`,
  },
  successButtonContainer: {
    backgroundColor: theme.palette.success.main,
    boxShadow: `0px 4px 0px ${theme.palette.success.dark}`,
  },
  lightSuccessButtonContainer: {
    backgroundColor: theme.palette.success.light,
    boxShadow: `0px 4px 0px ${theme.palette.success.contrastText}`,
  },
  errorButtonContainer: {
    backgroundColor: theme.palette.error.main,
    boxShadow: `0px 4px 0px ${theme.palette.error.dark}`,
  },
  buttonDisabled: {
    backgroundColor: theme.palette.grey[400],
    boxShadow: `0px 4px 0px ${theme.palette.grey[500]}`,
  },
  buttonGold: {
    background: theme.palette.utils.gradients.gold,
    boxShadow: `0px 4px 0px ${theme.palette.gold.shadow}`,
  },
  buttonSilver: {
    background: theme.palette.utils.gradients.silver,
    boxShadow: `0px 4px 0px ${theme.palette.silver.shadow}`,
  },
  buttonBronze: {
    background: theme.palette.utils.gradients.bronze,
    boxShadow: `0px 4px 0px ${theme.palette.bronze.shadow}`,
  },
  buttonPrimaryDark: {
    background: theme.palette.secondary.main,
    boxShadow: `0px 4px 0px ${theme.palette.secondary.dark}`,
  },
  buttonDark: {
    background: theme.palette.grey[600],
    boxShadow: `0px 4px 0px ${theme.palette.grey[700]}`,
  },
};
